// Dugout-mode drawing constants. Dormant for every other theme — read only behind a dugout gate
// (`isDugout(theme)` / `isDugoutTheme`), so knvb/frf/fmf/default never observe them.

/**
 * The icon set a new Dugout drawing starts in. Dugout has no in-tool shape toggle, so this constant
 * is the single source of truth for the default — flip it to `'alternateIcon'` to start new drawings
 * in symbols instead of shirts. An imported drawing's own top-level `iconType` still wins over this.
 */
export const DUGOUT_DEFAULT_ICON_TYPE: 'defaultIcon' | 'alternateIcon' =
  'defaultIcon';

/**
 * Fill applied to an icon's main shape in `alternateIcon` (symbol) mode: Dugout draws every symbol in
 * one neutral grey rather than the team colour. Mirrors the Dugout tool's `alternateIconColor`.
 */
export const ALTERNATE_ICON_COLOR = '#333';
